import React from 'react';
import { Table, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ProcessingFeeRow } from '../../../services/pw1312Api';

interface ResultTableProps {
  data: ProcessingFeeRow[];
  loading: boolean;
  queried: boolean;
  noData: boolean;
}

const ResultTable: React.FC<ResultTableProps> = ({ data, loading, queried, noData }) => {
  const columns: ColumnsType<ProcessingFeeRow> = [
    { title: '工繳代號', dataIndex: 'code', key: 'code', width: 120 },
    { title: '備忘1', dataIndex: 'memo1', key: 'memo1', ellipsis: true },
    { title: '備忘2', dataIndex: 'memo2', key: 'memo2', ellipsis: true },
  ];

  if (!queried) return null;
  if (noData) return <Empty description="查無此資料" style={{ marginTop: 40 }} />;

  return (
    <Table<ProcessingFeeRow>
      columns={columns}
      dataSource={data}
      rowKey="code"
      loading={loading}
      size="small"
      pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
    />
  );
};

export default ResultTable;
